<script lang="ts">
	import type { MobileActiveSection } from '$lib/types/home';

	import { mobileActiveSection } from './store';
	function setMovileActiveSection(section: MobileActiveSection) {
		$mobileActiveSection = section;
	}

	export let title: MobileActiveSection;
	export let count: number = 0;
</script>

{#if $mobileActiveSection == title}
	<button
		class="text-fx-grey-200 bg-fx-grey-600 px-4 py-2 rounded-2xl squircle-2xl"
		on:click={() => {
			setMovileActiveSection(title);
		}}
	>
		{title}
		{#if count}({count}){/if}
	</button>
{:else}
	<button
		class="px-4 py-2"
		on:click={() => {
			setMovileActiveSection(title);
		}}
	>
		{title}
		{#if count}({count}){/if}
	</button>
{/if}
